import { zipCode } from './helper/ValidatorRules'

const zipCodeValidator = {
  getMessage: () => 'Sorry, only letters, numbers (0-9), and symbol (-) is allowed.',
  validate: value => {
    return {
      valid: zipCode(value),
      data: {
        required: true
      }
    }
  }
}

export default zipCodeValidator
